import { FormControl, FormGroup } from '@angular/forms';
import { Model, ModelVendor, ModelType } from '@vendasta/protos/ai_assistants/v1alpha1';

export const DEFAULT_MODEL: Model = {
  id: '',
  vendor: ModelVendor.VENDOR_UNSET,
  type: ModelType.TYPE_UNSET,
  name: '',
  recommended: false,
  supportedReasoningEfforts: [],
};

export type AiModelConfigFormControls = {
  model: FormControl<Model | null>;
};

export class AiModelConfigurationForm extends FormGroup<AiModelConfigFormControls> {
  constructor(model?: Model) {
    super({
      model: new FormControl(model ?? DEFAULT_MODEL),
    });
  }

  toAssistantModel(): Model | null {
    const model = this.controls.model.getRawValue();
    if (model == null || (!model.id && (!model.vendor || model.vendor === ModelVendor.VENDOR_UNSET))) {
      return null;
    }
    return {
      id: model.id,
      vendor: model.vendor,
      type: model.type,
      name: model.name,
      recommended: model.recommended,
      supportedReasoningEfforts: model.supportedReasoningEfforts ?? [],
    };
  }
}
